import React, {useEffect, useState} from "react";
import {Save, XCircle} from "react-feather";
import Modal from "react-bootstrap/Modal";
import {useForm} from "react-hook-form";
import Select from "react-select";
import {POST} from "../../../api/adminApi";

export default function PushModal({
                                              modal: {show, user},
                                              setModal,
                                              getItems,
                                          }) {
    const {
        register,
        handleSubmit,
        formState: {errors},
        setValue,
        clearErrors,
    } = useForm();


    async function changeStatus(data) {
        const response = await POST(
            "/services/admin/api/master-change-point-notification",
            {
                phone: user.phone,
                comment: data.comment,
                id: user.id,
            }
        );
        if (response) {
            console.log(response)
        }

        if (response && response.success === true) {
            getItems();
            onHide();
        }
    }

    function onHide() {
        setModal({show: false, user: null});
        setValue("comment", "");
        clearErrors();
    }

    return (
        <Modal
            show={show}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={onHide}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Отправить push
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit(changeStatus)} autoComplete="off">
                    <div className="d-flex">
                        <div className="w-100">
                            <div className="admin-field">
                                <div className="d-flex w-100">
                                    <div className="mr-md-3 w-25">
                                        <label className="mb-0">Комментарии</label>
                                    </div>
                                    <textarea
                                        {...register("comment", {
                                            required: true,
                                        })}
                                        type="text"
                                        placeholder=""
                                        className="input-control w-75"
                                    />
                                </div>
                                {errors.comment && (
                                    <div className="text-danger mt-1 fz12">
                                        Обязательное поле
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-end gap-4">
                        <button
                            type="button"
                            onClick={onHide}
                            className="btn btn-outline-purple d-flex align-items-center btn-bg-warning text-white"
                        >
                            <XCircle size={14} className="mr-2"/>
                            Отмена
                        </button>

                        <button
                            type="submit"
                            className="btn d-flex align-items-center btn-bg-dark text-white"
                        >
                            <Save size={14} className="mr-2"/>
                            Отправить{" "}
                        </button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
}
